import { getRating, Pages } from "../../../utils/Utils"
import advantages_desk from '../../../img/planner/advantages_desk.svg'
import advantages_individual from '../../../img/planner/advantages_individual.svg'
import advantages_online from '../../../img/planner/advantages_online.svg'
import advantages_planner from '../../../img/planner/advantages_planner.svg'
import advantages_prepaid from '../../../img/planner/advantages_prepaid.svg'
import advantages_video from '../../../img/planner/advantages_video.svg'
import advantages_world_pays from '../../../img/planner/advantages_world_pays.svg'
/* eslint-disable eqeqeq */
export const getExpertsYoutubeParams = (isDesktop) => {
    var videoOptions = {
        width: isDesktop ? 'auto' : '100vw',
        height: 'auto',
        playerVars: {
            autoplay: 0,
            controls: 1,
            rel: 0,
            showinfo: 0,
            mute: 1,
            loop: 1
        },
    }
    return videoOptions
}
export const SeoTagName = {
    city: 'city',
    metro: 'metro',
    specialization: 'specialization',
    tag: 'tag',
    empty_tag : '_'
}
export const getAdvantagesArray = (isExperts, is5) => {
    const online = {title : "Занятия онлайн", icon : advantages_online, description : "На данной платформе — только онлайн-занятия. Это очень удобно, ведь вам не нужно тратить время на дорогу, и вы можете выбрать лучшего репетитора, не ограничиваясь вашим местоположением."}
    const virtual = {title : "Виртуальная доска", icon : advantages_desk, description : "Это онлайн-версия школьной доски, только лучше. Помогает сделать процесс объяснения материала более простым и наглядным."}
    const individual = {title : "Индивидуальные\nи групповые занятия", icon : advantages_individual, description : "Платформа поддерживает как индивидуальные, так и групповые видеозвонки. Каждый репетитор сам определяет, в каком формате получается более эффективная работа."}
    const quality = {title : "Качественная\nвидеосвязь", icon : advantages_video, description : "Стабильная видеосвязь полностью на российских технологиях."}
    const planner = {title : "Планировщик занятий", icon : advantages_planner, description : "Позволяет создать видеовстречи с клиентами на будущее и грамотно спланировать свой рабочий процесс."}
    const world_pays = {title : "Международные платежи", icon : advantages_world_pays, description : "В платформу встроена удобная система международной оплаты, что позволяет работать репетиторам не только из России."}
    const prepaid = {title : "Предоплата\nи оплата за\nнеявку", icon : advantages_prepaid, description : "Все видеовстречи на платформе предоплачиваются заранее в 100% размере. Если клиент отменяет занятие менее чем за сутки, то репетитор получает всю сумму на свой баланс."}
    const advantages4 = [online, virtual, individual, quality]
    const advantages5 = [online, virtual, prepaid, planner, world_pays]
    const advantagesExperts = [online, virtual, planner, world_pays, individual, quality]
    const array = isExperts ? advantagesExperts : is5 ? advantages5 : advantages4
    return array
}
export const getCityAndMetro = (seoTags) => {
    var arr = []
    for (const [key, value] of seoTags.entries()) {
        if (key != SeoTagName.specialization){
            arr.push(value)
        }
        
    }
     
    return arr
}
export const convertLinkToSeoTags = () =>{
    const seoTags = decodeURIComponent(window.location.pathname).includes(Pages.list + '/') ? decodeURIComponent(window.location.pathname).split(Pages.list + '/')[1].split('/') : []
    var mTags = new Map()
    for (let index = 0; index < seoTags.length; index++) {
            const seoTag = seoTags[index]
            // var tag = {}
            // tag[getSeoTagByIndex(index)] = seoTag
            mTags.set(getSeoTagByIndex(index), seoTag == SeoTagName.empty_tag ? "" : decodeURIComponent(seoTag))
        
    }
    if (!mTags.has(SeoTagName.metro)){
        mTags.set(SeoTagName.metro, "")
    }
    if (!mTags.has(SeoTagName.specialization)){
        mTags.set(SeoTagName.specialization, "")
    }
    if (!mTags.has(SeoTagName.tag)){
        mTags.set(SeoTagName.tag, "")
    }
    console.log("mTags = ", mTags)
    console.log("window.location.pathname = ", window.location.pathname)
    return mTags
}
export const convertEnglishTags = (tags, result) =>{
    var mTags = new Map()
    if (tags.has(SeoTagName.city)){
        mTags.set(SeoTagName.city, result.city)
    }
    if (tags.has(SeoTagName.metro)){
        mTags.set(SeoTagName.metro, result.metro)
    }
    if (tags.has(SeoTagName.specialization)){
        mTags.set(SeoTagName.specialization, result.specialization)
    }
    if (tags.has(SeoTagName.tag)){
        mTags.set(SeoTagName.tag, result.tag)
    }
    console.log("convertEnglishTags mTags = ", mTags)
    return mTags
}
export const getUrlByTags = (tags, tagName) =>{
    var url = Pages.list + '/'
    const city = tags.get(SeoTagName.city) == "" ? SeoTagName.empty_tag : tags.get(SeoTagName.city)
    const metro = tags.get(SeoTagName.metro) == "" ? SeoTagName.empty_tag : tags.get(SeoTagName.metro)
    const specialization = tags.get(SeoTagName.specialization) == "" ? SeoTagName.empty_tag : tags.get(SeoTagName.specialization)
    // const tag = tags.get(SeoTagName.tag) == "" ? SeoTagName.empty_tag : tags.get(SeoTagName.tag)
    
    var currentTag = tags.get(tagName)
    if (currentTag == ''){
        currentTag = SeoTagName.empty_tag
    }
    if (tagName == SeoTagName.city){
        return url += currentTag
    } else if (tagName == SeoTagName.metro){
        return url += city + '/' + currentTag
    } else if (tagName == SeoTagName.specialization){
        return url += city + '/' + metro + '/' + currentTag
    } else if (tagName == SeoTagName.tag){
        return url += city + '/' + metro + '/' + specialization + '/' + currentTag
    }
    return url
}
export const getSeoTagByIndex = (index) =>{
    if (index == 0){
        return SeoTagName.city
    } else if (index == 1){
        return SeoTagName.metro
    } else if (index == 2){
        return SeoTagName.specialization
    } else if (index == 3){
        return SeoTagName.tag
    }
}
export const generateRandomNumberFloat = (min, max) => {
    return parseFloat((Math.random() * (max - min) + min).toFixed(2))
}
function getRandomArbitrary(min, max) {
  return parseInt(Math.random() * (max - min) + min)
}
export const getAggregateRating = () => {
    return {
        "@type": "AggregateRating",
        "ratingValue": (4.43 + generateRandomNumberFloat(0.01, 0.1)),
        "bestRating": "5",
        "worstRating" : (2.2 + generateRandomNumberFloat(0.1, 0.2)), 
        "ratingCount": (8172 + getRandomArbitrary(0, 1000))
    }
}
export const createAggregateRating = (user) => {
    const countReviews = user.count_1_grade + user.count_2_grade + user.count_3_grade + user.count_4_grade + user.count_5_grade
    const rating = getRating(user)
    return {
        "@type": "AggregateRating",
        "ratingValue": rating,
        "bestRating": user.count_5_grade > 0 ? 5 : user.count_4_grade > 0 ? 4 : user.count_3_grade > 0 ? 3 : user.count_2_grade > 0 ? 2 : user.count_1_grade > 0 ? 1 : 0,
        "worstRating" : user.count_1_grade > 0 ? 1 : user.count_2_grade > 0 ? 2 : user.count_3_grade > 0 ? 3 : user.count_4_grade > 0 ? 4 : user.count_5_grade > 0 ? 5 : 0, 
        "ratingCount": countReviews
    }
}
export const isCustomMetaPages = () => {
    const pathname = decodeURIComponent(window.location.pathname)
    return pathname.includes(Pages.list) || pathname.includes(Pages.users) || pathname.includes(Pages.profile) || pathname.includes(Pages.blogs_post) || pathname.includes(Pages.search) || pathname.includes(Pages.ads_board + "/ads") || pathname.includes(Pages.ads_board + "/shikari")
}
// export const isCatalogsPage = () => {
//     const pathname = decodeURIComponent(window.location.pathname)
//     return pathname.includes(Pages.list)
// }

export const setConfigMetaTags = (config) => {
    const seo_config = config.seo_config
    if (seo_config){
        var isFound = false
        for (var k in seo_config) {
            if (seo_config.hasOwnProperty(k) && window.location.pathname.includes(k) && !window.location.pathname.includes(Pages.ads_board + "/")) {
                const configItem = seo_config[k]
                window.document.querySelector('meta[property="og:description"]').setAttribute("content", configItem.description)
                window.document.querySelector('meta[property="og:title"]').setAttribute("content", configItem.title)
                window.document.querySelector('meta[name="description"]').setAttribute("content", configItem.description)
                window.document.title = configItem.title
                isFound = true
            }
        }
        if (!isFound && !isCustomMetaPages()){
            console.log("setConfigMetaTags !isFound")
            window.document.querySelector('meta[name="description"]').setAttribute("content", "Общайтесь с экспертами и знаменитостями в Репетиторс.рф")
            window.document.querySelector('meta[property="og:description"]').setAttribute("content", "Общайтесь с экспертами и знаменитостями в Репетиторс.рф")
            window.document.querySelector('meta[property="og:title"]').setAttribute("content", "Общайтесь с экспертами и знаменитостями в Репетиторс.рф")
            window.document.title = "Общайтесь с экспертами и знаменитостями в Репетиторс.рф"
        }
    }
   
}

export const setLdJson = (name, priceRange, aggregateRating) => {
    const data =  {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "address" :
        {
            "@type": "PostalAddress",
            "addressCountry" :
            {
                "@type" : "Country",
                "name" : "Россия"
            }
        },
        "name" : name,
        "image" : "https://sozvon.pro/static/media/navbar_logo.bd8ff23253520c0dc524844f75513b4b.svg",
        "priceRange" : priceRange,
        "aggregateRating": aggregateRating
        // {
        //     "@type": "AggregateRating",
        //     "ratingValue": "4,48", //Random +- 0.05
        //     "bestRating": "5",
        //     "worstRating" : "2,3", //Random +- 0.1
        //     "ratingCount": "9172" //Random +- 500
        // }
    }     

    var script = window.document.createElement('script');
    script.type = "application/ld+json";
    script.innerHTML = JSON.stringify(data);
    window.document.getElementsByTagName('head')[0].appendChild(script);
}
export const setSeoMetaTags = (result, aggregateRating) => {
    window.document.querySelector('meta[property="og:title"]').setAttribute("content", result.full_query)
    window.document.querySelector('meta[property="og:type"]').setAttribute("content", "website")
    window.document.querySelector('meta[property="og:site_name"]').setAttribute("content", "Репетиторс.рф")
    window.document.querySelector('meta[property="og:description"]').setAttribute("content", result.description)
    window.document.querySelector('meta[name="description"]').setAttribute("content", result.description)
    window.document.querySelector('meta[property="og:image"]').setAttribute("content", "https://репетиторс.рф/static/media/navbar_logo.bd8ff23253520c0dc524844f75513b4b.svg")
    window.document.querySelector('meta[property="og:url"]').setAttribute("content", window.location.href)
    if (result.keywords){
        window.document.querySelector('meta[property="keywords"]').setAttribute("content",  result.keywords)
    }
    // var meta = document.createElement('meta');
    // meta.httpEquiv = "Keywords"
    // meta.content = result.meta_keywords
    // document.getElementsByTagName('head')[0].appendChild(meta);
    
    window.document.title = result.full_query
   
    setLdJson("Репетиторы, " + result.city, "от 👉300 ₽ за 60 минут до 4900 ₽ за 60 минут (на основе данных 35 719 анкет репетиторов).", aggregateRating)
    // console.log("setConfigMetaTags result = ", result)
    // console.log("setConfigMetaTags window.document.title = ", window.document.title)

}